import type { ReactNode } from 'react';
import { DataLoader } from '@/components/ui/DataLoader';
import { useCarryHoldings, useCarryStructure } from '../../hooks/useCarry';
import type {
  CarryHolding,
  CarryHoldings,
  CarryStructure,
} from '../../services/carryService';

interface PortalStructureDataProps {
  children: (structure: CarryStructure, positions: CarryHolding[]) => ReactNode;
}

export function PortalStructureData({ children }: PortalStructureDataProps) {
  const structureQuery = useCarryStructure();
  const holdingsQuery = useCarryHoldings();

  return (
    <DataLoader query={structureQuery}>
      {(structure: CarryStructure) => (
        <DataLoader query={holdingsQuery}>
          {(data: CarryHoldings) =>
            children(
              structure,
              data.holdings.filter((h) => h.units > 0)
            )
          }
        </DataLoader>
      )}
    </DataLoader>
  );
}
